import React, { useState } from 'react';

import Alert from '@amzn/meridian/alert';
import Link from '@amzn/meridian/link';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import { RTW_WIKI_URL } from 'src/config/ExternalLinks';
import { linkClickHandler } from 'src/utils/helpers';

interface NewFeatureProps {
  label: string;
  text: React.ReactNode;
}
const NewFeatureBanner = ({ label, text }: NewFeatureProps) => {
  const cleanedLabel = label.replace(' ', '');
  const [isOpen, setIsOpen] = useState(!localStorage.getItem(cleanedLabel));

  const onClose = () => {
    localStorage.setItem(cleanedLabel, 'true');
    setIsOpen(false);
  };

  return isOpen ? (
    <Row spacingInset={'400 none'} width="fill">
      <Alert width={'100%'} onClose={onClose} type="theme">
        <Text type="h100">New Feature Available!</Text>
        {text}{' '}
        <Link
          onClick={() => {
            linkClickHandler(RTW_WIKI_URL);
          }}
        >
          Learn more on our RTW wiki.
        </Link>
      </Alert>
    </Row>
  ) : (
    <></>
  );
};

export default NewFeatureBanner;
